import React from 'react';
import { RiEye2Line } from 'react-icons/ri';

export function ImagePlaceholder({ size = '50px' }: { size?: string }) {
  return <RiEye2Line size={size} className="text-white opacity-50" />;
}
